const PICKER_STORAGE_KEY = 'nowtarot_picker_lang';

export const CARD_OF_THE_DAY_PATHS = {
  es: '/es/carta-del-dia/',
  ar: '/ar/card-of-the-day/',
};

export function cardOfTheDayPath(lang) {
  return CARD_OF_THE_DAY_PATHS[lang] || '/card-of-the-day/';
}

export function rememberSpreadLanguage(lang) {
  if (!lang || lang === 'en') return;
  try {
    localStorage.setItem(PICKER_STORAGE_KEY, lang);
  } catch (error) {
    /* spread pages fall back to the browser language */
  }
}
